<div>
  <button class="action-button" mat-raised-button (click)="drawMeasurement()">
    <mat-icon>{{ measureModeSignal() === 'Enable Measure' ? drawIcon : editOffIcon }}</mat-icon>
    {{ measureModeSignal() }}
  </button>
</div>
<div>
  <button class="action-button" mat-raised-button (click)="clearMeasurement()">
    <mat-icon>{{ inkEraserIcon }}</mat-icon>
    Clear Measure
  </button>
</div>
